var exports = {
  "LV": "ProfileMessageField.module__wrap___Z21nQV",
  "ZZ": "ProfileMessageField.module__field___Z21nQV",
  "Qq": "ProfileMessageField.module__text___Z21nQV",
  "Kk": "ProfileMessageField.module__icon___Z21nQV",
};

module.exports = exports;
